import { axiosInstanceV2 } from './AxiosInstance.js';
const API_URL = '/auth';

export const login = async (email, password) => {
  try {
    const response = await axiosInstanceV2.post(`${API_URL}/login`, {
      identifier: email,
      password: password,
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    throw error;
  }
};

export const signUp = async (mobileNumber, email, password, firstName, lastName) => {
  try {
    const response = await axiosInstanceV2.post(`${API_URL}/signup`, {
      mobileNumber,
      email,
      password,
      firstName,
      lastName,
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    throw error;
  }
};

export const changePassword = async (identifier, oldPassword, newPassword) => {
  try {
    const response = await axiosInstanceV2.post(`${API_URL}/changepassword`, {
      identifier,
      oldPassword,
      newPassword,
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    throw error;
  }
};

export const requestPasswordReset = async (identifier) => {
  try {
    const response = await axiosInstanceV2.post(`${API_URL}/request-reset`, {
      identifier,
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    throw error;
  }
};

export const resetPassword = async (token, password) => {
  try {
    const response = await axiosInstanceV2.post(`${API_URL}/reset`, {
      token,
      password,
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    throw error;
  }
};

export const formatError = (error) => {
  if (typeof error === 'string') {
    return error;
  }
  if (error.message && typeof error.message === 'object') {
    return error.message.message || error.message.ariaLabel || 'An error occurred';
  }
  if (error.message) {
    return error.message;
  }
  return 'An unexpected error occurred';
};

export const saveTokenInLocalStorage = (response, navigate, setUser) => {
  localStorage.setItem('accessToken', response.data.token);
  localStorage.setItem('refreshToken', response.data.refreshToken);
  
  // Store the complete user object with isSuperAdmin
  const userDetails = {
    ...response.data.user, // This includes id, profileIds, isSuperAdmin
    email: response.data.user.email || '', // Add any missing fields if needed
  };
  
  localStorage.setItem('userDetails', JSON.stringify(userDetails));
  
  if (setUser) {
    setUser(userDetails);
  }
  
  if (navigate) {
    navigate('/placement-dashboard');
  }
};



export async function getMe() {
  const accessToken = localStorage.getItem('accessToken');
  if (!accessToken) {
    clearAuthData();
    throw new Error('No access token found');
  }

  try {
    const response = await axiosInstanceV2.get('/auth/me', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      clearAuthData();
    }
    throw error;
  }
}

// Add helper function to clear auth data
function clearAuthData() {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('userDetails');
  localStorage.removeItem('refreshToken');
}
